export const en = {
    all: 'All',
    'region-except': '{region} (except {except})'
};
